import React from 'react';

const ChevronDown: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.2 8.40006C3.53137 7.95823 4.15817 7.86869 4.6 8.20006L12 13.7501L19.4 8.20006C19.8418 7.86869 20.4686 7.95823 20.8 8.40006C21.1314 8.84189 21.0418 9.46869 20.6 9.80006L12.6 15.8001C12.2444 16.0667 11.7556 16.0667 11.4 15.8001L3.4 9.80006C2.95817 9.46869 2.86863 8.84189 3.2 8.40006Z"
      />
    </svg>
  );
};

export default ChevronDown;
